<template>
  <core-modal
    @close="closeModal"
    :stateOpen="isOpen"
    containerStyle="width: 40%"
  >
    <div slot="header" class="p-3 text-uppercase">
      {{ $t('reservation.invoice.send-invoice-documents') }}
    </div>
    <div slot="body">

      <div style="text-align: right; margin-bottom: 15px">
        <select :item.sync="lang" v-model="lang">
          <option :key=key :value=language v-for="(language, key) in langs">{{ language }}
          </option>
        </select>
      </div>

      <core-editor class="col-sm-12 mb-2" v-model="templateText"></core-editor>
      <br />
      <core-lever
        class="ml-3"
        :label="$t('reservation.invoice.attach-travel-docs')"
        labelClass="ml-3"
        v-model="attachDocs"
      ></core-lever>
    </div>
    <div slot="footer">
      <button
        v-show="!isSending"
        type="button"
        @click="sendInvoice"
        class="btn btn-primary rounded m-0"
      >
        {{ $t('general.send') }}
      </button>
      <span><img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-if="isSending" class="rotating" /></span>
    </div>
  </core-modal>
</template>

<script>
import Reservation from '@/services/hatsApi/Reservation'
import MailTemplate from '@/services/hatsApi/MailTemplate'

export default {
  props: {
    reservationId: {
      default: '',
      type: String | Number,
      required: true
    },
    language: {
      default: null,
      type: Object,
      required: true
    },
    isOpen: {
      default: false,
      type: Boolean,
      required: true
    },
    customerFirstName: {
      default: '',
      type: String,
      required: true
    },
    customerLastName: {
      default: '',
      type: String,
      required: true
    }
  },
  data () {
    return {
      templateText: '',
      lang: this.language.code,
      langs: [
        'EN', 'DE', 'NL'
      ],
      attachDocs: false,
      invoiceWithDocs: null,
      invoiceWithoutDocs: null,
      isSending: false
    }
  },
  watch: {
    attachDocs: {
      handler () {
        this.prepareTemplateText()
      },
      immediate: true
    },
    customerFirstName: {
      handler () {
        this.prepareTemplateText()
      }
    },
    customerLastName: {
      handler () {
        this.prepareTemplateText()
      }
    },
    lang: {
      handler () {
        this.prepareTemplateText()
      }
    },
    invoiceWithDocs: {
      handler () {
        this.prepareTemplateText()
      }
    },
    invoiceWithoutDocs: {
      handler () {
        this.prepareTemplateText()
      }
    }
  },
  async created () {
    await this.init()
  },
  methods: {
    getTextField (data) {
      let key = 'text_' + this.lang
      return (!!data && (key in data)) ? data[key] : ''
    },
    async init () {
      this.invoiceWithDocs = (await MailTemplate.getTemplate('invoice_with_docs')).data.data
      this.invoiceWithoutDocs = (await MailTemplate.getTemplate('invoice_without_docs')).data.data
    },
    closeModal () {
      this.$emit('closeModal')
    },
    async sendInvoice () {
      this.isSending = true
      try {
        const payload = {
          text: this.templateText,
          send_documents: this.attachDocs ? 1 : 0
        }
        const saveResponse = await Reservation.sendTickets(
          this.reservationId,
          payload
        )
        this.isSending = false
        if (saveResponse.data.success) {
          this.closeModal()
        }
      } catch (e) {
        this.isSending = false
        console.log('Error :', e)
      }
    },
    prepareTemplateText () {
      let text = this.attachDocs
        ? this.getTextField(this.invoiceWithDocs)
        : this.getTextField(this.invoiceWithoutDocs)
      text = text.replace('#person_name#', this.customerFirstName + ' ' + this.customerLastName)
      this.templateText = text.replace('#reservation_id#', this.reservationId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/invoice/SendInvoiceDocsModal.vue